// extracted by mini-css-extract-plugin
export default {"list":"list__Mh7m0","listItem":"listItem__4oJP6","tireIcon":"tireIcon__Dn65h"};